export function officeAddressStreet({ addressLine, addressLineOther }) {
  return `${addressLine} ${addressLineOther}`;
}

export function officeAdressLocation({ city, country, postalCode, state }) {
  return `${postalCode} ${city}, ${state}, ${country}`;
}
